<script>
  import PellEditor from './PellEditor.svelte'
  import PellEditor2 from './PellEditor2.svelte'

  export let data
  export let currentId
  export let showEdit
  export let loggedIn
  export let user

  let curIndex = data.entries.findIndex(x => x.id === currentId)

  //let filemanager = false
  let activeTab = 'content'

  function deleteItem() {
    var result = confirm('Are you sure you want to delete this item?')
    if (result) {
      let filteredAry = data.entries.filter(e => e.id !== currentId)
      data.entries = filteredAry
      data = data
      showEdit = false
      localStorage.setItem('json', JSON.stringify(data))
    }

    document.getElementById('save').click()
  }

  function move(array, from, to) {
    if (to === from) return array

    var target = array[from]
    var increment = to < from ? -1 : 1

    for (var k = from; k != to; k += increment) {
      array[k] = array[k + increment]
    }
    array[to] = target
    return array
  }

  function movedown() {
    let index = data.entries.findIndex(x => x.id === currentId)
    let newindex = index + 1

    if (typeof data.entries[newindex] !== 'undefined') {
      data.entries = move(data.entries, index, index + 1)
      data = data
      localStorage.setItem('json', JSON.stringify(data))
    }
  }

  function save() {
    localStorage.setItem('json', JSON.stringify(data))
    showEdit = false
  }

  function deleteFile(myid, file) {
    file = basename(file)

    var result = confirm('Are you sure you want to delete this image?')
    if (result) {
      let formData = new FormData()
      formData.append('username', user.username)
      formData.append('filename', file)

      fetch('https://api.sitefiction.io/image/delete', {
        headers: {
          authorization: user.authToken,
        },
        body: formData,
        method: 'post',
      })
        .then(response => response.json())
        .then(res => {
          console.log('Success:', res)

          let index = data.entries.findIndex(x => x.id === currentId)

          data.entries[index].images = data.entries[index].images.filter(
            e => e.id !== myid
          )
          data = data
        })
    }
  }

  function basename(path) {
    return path.split('/').reverse()[0]
  }
</script>


<button class="btn btn-outline-success float-right" on:click="{save}" id="save">Save</button>

<div class="tabs">
  <ul class="nav nav-pills">
    <li class="nav-item">
      <span
        class="nav-link"
        class:active={activeTab === 'content'}
        on:click={() => (activeTab = 'content')}>
        Content
      </span>
    </li>

    <li class="nav-item">
      <span
        class="nav-link"
        class:active={activeTab === 'design'}
        on:click={() => (activeTab = 'design')}>
        Design
      </span>
    </li>
    <li class="nav-item">
      <span
        class="nav-link"
        class:active={activeTab === 'options'}
        on:click={() => (activeTab = 'options')}>
        Options
      </span>
    </li>

  </ul>
</div>

{#if activeTab == 'content'}
  {#each data.entries as item}
    {#if item.id == currentId}
      {#if item.fields.includes('title')}
        <label>Title</label>
        <input type="text" class="form-control" bind:value={item.title} />
      {/if}

      {#if item.fields.includes('tagline')}
        <label>Tagline</label>
        <input type="text" class="form-control" bind:value={item.tagline} />
      {/if}

      {#if item.fields.includes('body')}
        <label>Body</label>
        <PellEditor bind:item />
      {/if}

      {#if item.fields.includes('extended')}
        <label>Extended</label>
        <PellEditor2 bind:item />
      {/if}

      {#if item.fields.includes('images')}
        <label>
          {#if item.fields.includes('image')}Image{:else}Gallery{/if}
        </label>

        {#if !loggedIn}
          <input
            type="text"
            class="form-control"
            placeholder="e.g. https://examplepage.net/image.jpg"
            bind:value={item.image} />

        {:else}
          <ul class="list-group">
            {#each item.images as img, i}
              <li
                class="list-group-item"
                style="padding: 10px; padding-bottom: 5px;">

                <div class="imgbox" style="background-image: url({img.url});" />

                <input
                  type="hidden"
                  class="form-control"
                  placeholder="url"
                  bind:value={img.url} />

                <button
                  class="btn btn-outline-secondary float-right"
                  on:click={deleteFile(img.id, img.url)}>
                  <i class="fa fa-trash" style="margin-right: 0;" />
                </button>

              </li>
            {/each}

          </ul>

          {#if item.fields.includes('image') && item.images.length < 1}
            <Uppload bind:item bind:user />
          {:else if !item.fields.includes('image')}
            <Uppload bind:item bind:user />
          {/if}
        {/if}
      {/if}

      {#if item.fields.includes('video')}
        <label>YouTube video URL</label>
        <input
          type="text"
          class="form-control"
          placeholder="e.g. https://www.youtube.com/watch?v=KsCizHUVlxc"
          bind:value={item.video} />
      {/if}

      {#if item.fields.includes('bgimage')}
        <label>Background-Image</label>
        <input
          type="text"
          class="form-control"
          placeholder="e.g. https://website.com/image.jpg"
          bind:value={item.image} />
      {/if}
    {/if}
  {/each}

{:else if activeTab == 'design'}
  {#each data.entries as item}
    {#if item.id == currentId}
      {#if item.fields.includes('flip')}
        <label>Layout</label>
        <div class="btn-group w-100">
          <button
            class="btn btn-outline-dark w-33"
            class:active={item.flip === false}
            on:click={() => (item.flip = false)}>
            Text Left
          </button>
          <button
            class="btn btn-outline-dark w-33"
            class:active={item.flip === true}
            on:click={() => (item.flip = true)}>
            Text Right
          </button>
        </div>
      {/if}

      <label class="mt-4">Background-color</label>
      <div>

        <div class="btn-group w-100">
          <button
            class="btn btn-outline-dark w-33"
            class:active={item.color === ''}
            on:click={() => (item.color = '')}>
            <div class="microswatch" style="background-color: white;" />
            White
          </button>
          <button
            class="btn btn-outline-dark w-33"
            class:active={item.color === 'primary-color'}
            on:click={() => (item.color = 'primary-color')}>
            <div class="microswatch primary-color" />
            Primary
          </button>
          <button
            class="btn btn-outline-dark w-33"
            class:active={item.color === 'secondary-color'}
            on:click={() => (item.color = 'secondary-color')}>
            <div class="microswatch secondary-color" />
            Secondary
          </button>
        </div>
      </div>
    {/if}
  {/each}

{:else}
  <label class="d-block">Move</label>

  <button class="btn btn-outline-dark w-100" on:click={movedown}>
    <i class="fa fa-arrow-down" />
    Move Down
  </button>

  <label class="d-block mt-3">Delete</label>

  {#if data.entries[curIndex] && data.entries[curIndex].images.length}
    <div class="alert alert-warning">
      You cannot delete an item that contains images. Please delete the images
      first.
    </div>
  {:else}
    <button class="btn btn-outline-danger w-100 delete" on:click={deleteItem}>
      <i class="fa fa-trash" />
      Delete
    </button>
  {/if}

{/if}

<style>
  .microswatch {
    width: 13px;
    height: 13px;
    margin-right: 5px;
    border: 1px solid black;
    display: inline-block;
  }

  .tabs {
    margin-bottom: 10px;
  }

  #save{
    width: 100px;
  }

</style>
